import { NOTIFICATION_TYPES } from "../notification/notification.constants"
import {
  fetchBootcampCipSubmissions,
  getBootcampAcceleratedUploadUrlAndAsset,
  submitAssetUrlForBootcamp,
  uploadFile,
} from "./vod.apis"
import {
  GAME_RECORD_HINTS,
  GAME_RECORD_HINTS_TITLE,
  MAX_FILE_SIZE,
  UPLOADING_STEP,
  VOD_TYPE,
} from "./vod.constants"
import {
  checkFileSize,
  checkFileType,
  getFileExtensionForUploading,
  getReadableBytes,
} from "./vod.utils"

const state = {
  selectedGame: null,
  error: "",
  uploadingStep: UPLOADING_STEP.READY_TO_UPLOAD,
  progress: 0,
  cancelFunction: () => {}, // used to cancel uploading
  fileToUpload: null,
  vodType: null,
  bootcampSubmissionGroupKey: null,
}
const getters = {
  selectedGame: state => state.selectedGame,
  error: state => state.error,
  uploadingStep: state => state.uploadingStep,
  progress: state => state.progress,
  cancelFunction: state => state.cancelFunction,
  recordHintTitle: state => GAME_RECORD_HINTS_TITLE(state.selectedGame),
  recordHints: state => GAME_RECORD_HINTS(state.selectedGame),
  fileToUpload: state => state.fileToUpload,
  readableBytes: state => getReadableBytes(state.fileToUpload.size),
  bootcampSubmissionGroupKey: state => state.bootcampSubmissionGroupKey,
}
const mutations = {
  setSelectedGame: (state, game) => (state.selectedGame = game),
  setError: (state, error) => (state.error = error),
  setUploadingStep: (state, step) => (state.uploadingStep = step),
  setProgress: (state, progress) => (state.progress = progress),
  setCancelFunction: (state, fn) => (state.cancelFunction = fn),
  setFileToUpload: (state, fileToUpload) => (state.fileToUpload = fileToUpload),
  setVodType: (state, vodType) => (state.vodType = vodType),
  setBootcampSubmissionGroupKey: (state, key) =>
    (state.bootcampSubmissionGroupKey = key),
}
const actions = {
  async uploadFile (
    { dispatch, commit, state },
    { file, vodType, bootcampKey, extId }
  ) {
    commit("setError", "")
    commit("setFileToUpload", file)
    commit("setVodType", vodType)
    const validFile = await dispatch("checkFile", file)
    if (!validFile) return
    if (vodType === VOD_TYPE.CONTENTFUL_ENTRY) {
      if (!state.bootcampSubmissionGroupKey) {
        await dispatch("fetchBootcampCipSubmissions", { bootcampKey, extId })
      }
      const extension = getFileExtensionForUploading(file)
      const uploadInfo = await dispatch(
        "getBootcampAcceleratedUploadUrlAndAsset",
        {
          bootcampKey,
          fileExtension: extension,
        }
      )
      if (state.error) {
        return
      }
      commit("setUploadingStep", UPLOADING_STEP.UPLOADING)
      await uploadFile(uploadInfo.upload_url, file)
      await submitAssetUrlForBootcamp(
        bootcampKey,
        state.bootcampSubmissionGroupKey,
        uploadInfo.asset_url
      )
    }
    if (!state.error && state.progress === 100) {
      commit("setUploadingStep", UPLOADING_STEP.UPLOADED)
      dispatch(
        "Notification/addNotification",
        {
          type: NOTIFICATION_TYPES.SUCCESS,
          message: "Uploaded",
        },
        { root: true }
      )
      commit("setProgress", 0)
    }
  },
  checkFile ({ state, commit }, file) {
    // check file type
    const validFileType = checkFileType(file, state.selectedGame)
    if (!validFileType) {
      commit("setError", "File type is not supported.")
      return false
    }
    const validFileSize = checkFileSize(file)
    if (!validFileSize) {
      commit(
        "setError",
        `File is larger than ${getReadableBytes(MAX_FILE_SIZE)}`
      )
      return false
    }
    return true
  },
  cancelUploading ({ state, commit }) {
    state.cancelFunction()
    commit("setUploadingStep", UPLOADING_STEP.READY_TO_UPLOAD)
  },
  async fetchBootcampCipSubmissions ({ commit }, { bootcampKey, extId }) {
    const data = await fetchBootcampCipSubmissions(bootcampKey, extId)
    commit("setBootcampSubmissionGroupKey", data.data.clip_submission_group.key)
  },

  async getBootcampAcceleratedUploadUrlAndAsset (
    { commit, state },
    { bootcampKey, fileExtension }
  ) {
    const data = await getBootcampAcceleratedUploadUrlAndAsset(
      bootcampKey,
      state.bootcampSubmissionGroupKey,
      fileExtension
    )
    return data.data.upload_info
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/vod/vod.module.js